/**
 * Copyright (C) 2017 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiBase from '@here/lui-base'
import scopedCss from 'lui-tag.scss'
import template from 'lui-tag.html'

export default class LuiTag extends LuiBase {
  static get is() {
    return 'lui-tag'
  }

  static get cssClassToggles() {
    return ['positive', 'negative', 'significant']
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  static get hasLuiElementsInShadowDom() {
    return false
  }

  get disabled() {
    return this.hasAttribute('disabled')
  }

  get removable() {
    return this.hasAttribute('removable')
  }

  get removeButton() {
    this._removeButton = this._removeButton || this.shadowRoot.querySelector('.lui-tag__remove-button')
    return this._removeButton
  }

  onConnected() {
    super.onConnected()

    this.delay(() => {
      this._registerEvents()
    })
  }

  onDisconnected() {
    super.onDisconnected()
    this._unregisterEvents()
  }

  _registerEvents() {
    if (this.disabled || !this.removable) {
      return
    }
    this._onClickRemoveIconBound = this._onClickRemoveIconBound || this._onClickRemoveIcon.bind(this)
    this.removeButton.addEventListener('click', this._onClickRemoveIcon)
  }

  _unregisterEvents() {
    this.removeButton.removeEventListener('click', this._onClickRemoveIconBound)
  }

  _onClickRemoveIcon(event) {
    event.stopPropagation()
    this.dispatchEvent(new CustomEvent('lui-tag:removeClicked', { bubbles: true, composed: true }))
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-tag/lui-tag.js
// module id = 347
// module chunks = 0 1 23